var symphony = symphony || {};

;
(function () {
    symphony.currentDow = null;
    symphony.operationHoursSections = symphony.operationHoursSections || [];
    symphony.operationHoursDisplayCounter = 0;
    symphony.operationHoursDisplay = function () {
        if (document.querySelector('.operationHoursAdvanced-container') == null) {
            if (symphony.operationHoursDisplayCounter < 10) {
                setTimeout(function () {
                    symphony.operationHoursDisplay();
                }, 1000);
                symphony.operationHoursDisplayCounter++;
            }
            return;
        }

        // bold today's hours
        symphony.operationHoursBoldToday();

        // turn on open sign if it's open
        symphony.operationHoursSetOpenSign();
    };

    symphony.getCurrentDow = function () {
        if (symphony.currentDow == null) {
            symphony.currentDow = 'sunday';
            switch (new Date().getDay()) {
                case 1:
                    symphony.currentDow = 'monday';
                    break;
                case 2:
                    symphony.currentDow = 'tuesday';
                    break;
                case 3:
                    symphony.currentDow = 'wednesday';
                    break;
                case 4:
                    symphony.currentDow = 'thursday';
                    break;
                case 5:
                    symphony.currentDow = 'friday';
                    break;
                case 6:
                    symphony.currentDow = 'saturday';
                    break;
            }
        }
    };

    // iterate over keys to check if the center is open today
    symphony.operationHoursBoldToday = function (containerStr) {
        var containers = document.querySelectorAll('.operationHoursAdvanced-container');
        if (containerStr) {
            containers = [document.querySelector(containerStr)];
        }
        if (containers.length > 0) {
            symphony.getCurrentDow();

            for (var j = 0; j < containers.length; j++) {
                var container = containers[j];
                var days = container.querySelectorAll('.operationHoursAdvanced-featured .operationHoursAdvanced-' + symphony.currentDow + '-ui');
                for (var i = 0; i < days.length; i++) {
                    days[i].classList.add('u-bold');
                }
            }
        }
    };

    // iterate over open times to check if the center is open right now
    // if so, check when it will be closed, ex: "Closes at 8 PM"
    // if not, check when it will be open next, ex: "Opens at 9 AM Fri"
    symphony.operationHoursSetOpenSign = function (containerStr) {
        var containers = document.querySelectorAll('.operationHoursAdvanced-container');
        if (containerStr) {
            containers = [document.querySelector(containerStr)];
        }
        if (containers.length > 0) {
            symphony.getCurrentDow();

            for (var j = 0; j < containers.length; j++) {
                var container = containers[j];
                for (var i = 0; i < symphony.operationHoursSections.length; i++) {
                    var elm = container.querySelector('#operationHoursAdvanced-' + symphony.operationHoursSections[i].id);
                    if (elm) {
                        // check to see if the center is open right now
                        var isOpen = false;
                        var nextDay = '';
                        var nextTime = '';
                        var rightNow = moment(new Date());

                        var hours = $.grep(symphony.operationHoursSections[i].hours, function (x) {
                            return x.name == symphony.currentDow;
                        });
                        for (var ii = 0; ii < hours.length; ii++) {
                            var d = new Date();
                            var open = moment(d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear() + ' ' + hours[ii].open, 'MM/DD/YYYY HH:mm A');
                            var close = moment(d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear() + ' ' + hours[ii].close, 'MM/DD/YYYY HH:mm A');

                            var thisIsOpen = rightNow.isAfter(open) && close.isAfter(rightNow);
                            var isOpenBetween = false;
                            var isOpenAfter = false;
                            if (ii > 0) {
                                var prevClose = moment(d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear() + ' ' + hours[ii - 1].close, 'MM/DD/YYYY HH:mm A');
                                isOpenBetween = rightNow.isAfter(prevClose) && open.isAfter(rightNow);
                            } else {
                                isOpenAfter = open.isAfter(rightNow);
                            }
                            isOpen = isOpen || thisIsOpen;
                            if (isOpen && nextTime.trim().length == 0) {
                                nextTime = hours[ii].close;
                            } else if (isOpenBetween) { // it's already open
                                nextTime = hours[ii].open;
                            } else if (isOpenAfter && nextTime.trim().length == 0) { // it's already open
                                nextTime = hours[ii].open;
                            }
                        }

                        if (nextTime.trim().length == 0) { // the next time has to be on a different day
                            var daysOfWeek1 = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                            var daysOfWeek2 = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                            var newDowArr = daysOfWeek2.splice(daysOfWeek2.indexOf(symphony.currentDow) + 1).concat(daysOfWeek1.splice(0, daysOfWeek1.indexOf(symphony.currentDow)));
                            for (var ii = 0; ii < newDowArr.length; ii++) {
                                if (nextTime.trim().length == 0) {
                                    // only get the first of each
                                    var nextHours = $.grep(symphony.operationHoursSections[i].hours, function (x, i) {
                                        return x.name == newDowArr[ii];
                                    })[0];
                                    if (nextHours) {
                                        nextTime = nextHours.open;
                                        nextDay = newDowArr[ii][0].toUpperCase() + newDowArr[ii].slice(1); // uppercase full day
                                        //nextDay = nextHours.title;
                                    }
                                }
                            }
                        }

                        nextTime = nextTime.replace(':00', '');

                        if (isOpen) {
                            elm.classList.add('is-open');
                            // add "Closes at..." text
                            var span = elm.querySelector('.operationHoursAdvanced-openSign span');
                            if (span) {
                                span.innerText = "Closes at " + nextTime;
                            }
                        } else {
                            elm.classList.remove('is-open');
                            // add "Opens at..." text
                            var span = elm.querySelector('.operationHoursAdvanced-openSign span');
                            if (span) {
                                span.innerText = "Opens " + nextDay + " at " + nextTime;
                            }
                        }
                    }
                }
            }
        }
        symphony.operationHoursSections = [];
    };

    symphony.getOperationHoursSummary = function (data) {
        var newData = JSON.parse(JSON.stringify(data));
        newData.featured = false;
        return symphony.getOperationHoursHtml(newData, true);
    };

    symphony.getOperationHoursHtml = function (data, barebones) {
        barebones = barebones || false;

        // all the guts for processing and rendering hours of operation
        // input data, output HTML


        if (data.featured) {
            if (barebones) {
                var daysHtml = '';

                if (data.renderedDays && data.renderedDays.normal) {
                    for (var i = 0; i < data.renderedDays.normal.length; i++) {
                        daysHtml += symphony.templates.operationHoursAdvancedFeaturedDay({
                            title: data.renderedDays.normal[i].title,
                            name: data.renderedDays.normal[i].name,
                            enabled: data.renderedDays.normal[i].enabled,
                            hours: data.renderedDays.normal[i].hours
                        });
                    }
                }
                return daysHtml;
            }

            return symphony.templates.operationHoursAdvancedFeaturedSection(data);

        } else {
            if (barebones) {

                var daysHtml = '';

                if (data.renderedDays && data.renderedDays.condensed) {
                    for (var i = 0; i < data.renderedDays.condensed.length; i++) {
                        daysHtml += symphony.templates.operationHoursAdvancedDay({
                            title: data.renderedDays.condensed[i].title,
                            hours: data.renderedDays.condensed[i].hours
                        });
                    }
                }
                return daysHtml;
            }

            return symphony.templates.operationHoursAdvancedSection(data);

        }
    };

    symphony.expandOperationHours = function (elm) {
        var $parents = $(elm).parents('.operationHoursAdvanced-unfeatured-container, .operationHoursAdvanced-featured');
        if ($parents.length > 0) {
            elm = $parents[0];
        }
        elm.classList.toggle('expanded');
    };
})();
